/* eslint-disable key-spacing */
import { defaultSuggestionListTheme } from '../../src/SuggestionList/theme';

export const defaultDropDownSelectTheme = {
  ...defaultSuggestionListTheme,
  clearIcon:                  'dropdownselect-clear-icon',
  input:                      'dropdownselect-input',
  inputWrapper:               'dropdownselect-input-wrapper',
  inputWrapperDisabled:       'disabled',
  inputWrapperFocused:        'focused',
  inputWrapperInvalid:        'danger',
  inputWrapperRequired:       'required',
  selectIcon:                 'dropdownselect-select-icon',
  selectIconClosed:           'closed',
  selectIconOpened:           'opened',
  wrapper:                    'dropdownselect-wrapper',
};
/* eslint-enable key-spacing */
